import React from "react";
import ContentLoader from "styled-content-loader";

const LoadingBars = ({ length }) =>
  Array.from({ length }, (_, index) => (
    <div style={{ borderRadius: "5px", margin: "4px 3px 3px 3px" }} key={index}>
      ContentLoading
    </div>
  ));

const ContentLoading = (props) => (
  <ContentLoader
    backgroundColor="#e6e6e6"
    foregroundColor="#f0f0f0"
    isLoading={true}
  >
    <LoadingBars length={props.loadingFor === "sidedrawer" ? 13 : 11} />
  </ContentLoader>
);

export default ContentLoading;
